import MapComponent from "./Components/MapComponent.tsx";
import ContactForm from "./Components/ContactForm.tsx";
import { Helmet } from 'react-helmet-async';

export const Contact = () => {

    return (
        <>
            <Helmet>
                <title>Kontakt | Biuro rachunkowe Saldo.pl | Cieszyn i Bielsko-Biała</title>
                <meta name="description" content="Skontaktuj się z biurem rachunkowym Saldo.pl. Oferujemy profesjonalne usługi księgowe w Cieszynie. Telefon, email, formularz kontaktowy." />
                <meta name="keywords" content="kontakt biuro rachunkowe, księgowa Cieszyn kontakt, telefon do księgowej, adres biuro rachunkowe, formularz kontaktowy" />
                <link rel="canonical" href="https://podatki-saldo.pl/contact" />
                <meta property="og:title" content="Kontakt z biurem rachunkowym Saldo.pl" />
                <meta property="og:description" content="Skontaktuj się z nami - telefon, email, formularz kontaktowy. Odpowiemy na wszystkie Twoje pytania." />
                <meta property="og:url" content="https://podatki-saldo.pl/contact" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="main-content" style={{ gap: "0"}}>
                <div className="dark-section contact-first">
                    <div className="contact-first-left">
                        <div className="contact-header"><h3>Zadzwoń do nas lub napisz maila!</h3></div>
                        <div className="contact-data">
                            <ul>
                                <li><a href="tel:+48 (33) 476 19 40"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48 (33) 476 19 40</a></li>
                                <li><a href="tel:+48  517 427 066"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48  517 427 066</a></li>
                                <li><a href="tel:+48 512 054 425"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48 512 054 425</a></li>
                                <li><a href="tel:+48 513 010 265"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48 513 010 265</a></li>
                                <li><a href="tel:+48 502 457 892"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48 502 457 892</a></li>
                                <li><a href="tel:+48 517 262 372"><img src="/icons/phone-call.png" width="30" height="30" alt="phone"/>+48 517 262 372</a></li>
                            </ul>
                            <ul>
                                <li><a href="mailto:agnieszka.bukowczan@podatki-saldo.pl"><img src="/icons/mail.png" width="30" height="30" alt="phone"/>agnieszka.bukowczan@podatki-saldo.pl</a></li>
                                <li><a href="mailto:biuro@podatki-saldo.pl"><img src="/icons/mail.png" width="30" height="30" alt="phone"/>biuro@podatki-saldo.pl</a></li>
                                <li><a href="mailto:katarzyna.krawczyk@podatki-saldo.pl"><img src="/icons/mail.png" width="30" height="30" alt="phone"/>katarzyna.krawczyk@podatki-saldo.pl</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="contact-first-right">
                        <div className="contact-header">Albo wykorzystaj formularz kontaktowy</div>
                        <div className="contact-form">
                            <ContactForm />
                        </div>
                    </div>

                </div>
                <div className="white-section contact-map" style={{padding:"0"}}>
                    <div>
                        <MapComponent/>
                    </div>
                </div>
            </div>
        </>
    )
}